import { Record } from 'immutable';

import { UserRole } from 'enums/user-role';
import { TeamMemberStatus, TeamMemberStatusLabel } from 'enums/team-member-status';
import { toRelativeFromNow } from 'utils/DateHelper';
import { getMainRole } from 'utils/HierarchyRole';
import Hydrator from 'utils/Hydrator';

const TeamMemberModelRecord = Record({
  id: 0,
  name: '',
  email: '',
  status: 0,
  roles: [],
  lastLogin: new Date(),
  userType: '',
  entity: {},
  champion: false,
  team: {},
});

export default class TeamMemberModel extends TeamMemberModelRecord {
  static deserialize(jsonObject = {}) {
    if (!jsonObject) {
      return undefined;
    }

    const mapProperties = {
      lastLogin: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new TeamMemberModel(hydrated);
  }

  get statusAsString() {
    return TeamMemberStatusLabel[this.status];
  }

  hasRole(role) {
    return this.roles.indexOf(role) >= 0;
  }

  isTeamChampion() {
    return this.champion;
  }

  isNetworkManager() {
    return this.hasRole(UserRole.networkManager);
  }

  isCompanyManager() {
    return this.hasRole(UserRole.companyManager);
  }

  hasStatusActive() {
    return this.status === TeamMemberStatus.active;
  }

  hasStatusDeactivated() {
    return this.status === TeamMemberStatus.deactivated;
  }

  hasStatusPending() {
    return this.status === TeamMemberStatus.pending;
  }

  hasStatusRejected() {
    return this.status === TeamMemberStatus.rejected;
  }

  getLastLoginRelative() {
    return this.lastLogin ? toRelativeFromNow(this.lastLogin, { other: 'do MMM yyyy' }) : '-';
  }

  getEnterpriseRole() {
    return getMainRole(this.roles);
  }

  getCompanyId() {
    return this.getIn(['entity', 'entityId']);
  }

  toOption() {
    return {
      value: this.id,
      label: this.name,
    };
  }
}
